import { API_BASE } from '../config/api';
import { optimizeImageFile } from '../utils/imageOptimization';

const parse = async (response) => {
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(payload.error || 'Commercial service request failed.');
    error.status = response.status;
    error.code = payload.code;
    throw error;
  }
  return payload;
};

export const fetchPublicCatalog = ({ region = 'IN', currency = 'INR', signal } = {}) =>
  fetch(`${API_BASE}/api/commercial/public/catalog?region=${encodeURIComponent(region)}&currency=${encodeURIComponent(currency)}`, { signal }).then(parse);

export const fetchCommercialResource = (resource, token, signal, filters = {}) => {
  const query = new URLSearchParams(Object.entries(filters).filter(([, value]) => value !== '' && value !== undefined && value !== null));
  return fetch(`${API_BASE}/api/commercial/admin/${encodeURIComponent(resource)}${query.size ? `?${query}` : ''}`, { headers: { Authorization: `Bearer ${token}` }, signal }).then(parse);
};

export const createCommercialResource = (resource, values, token, reason) =>
  fetch(`${API_BASE}/api/commercial/admin/${encodeURIComponent(resource)}`, {
    method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, 'x-confirm-commercial-change': 'true', 'x-change-reason': reason },
    body: JSON.stringify(values),
  }).then(parse);

export const updateCommercialResource = (resource, id, values, token, reason) =>
  fetch(`${API_BASE}/api/commercial/admin/${encodeURIComponent(resource)}/${encodeURIComponent(id)}`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, 'x-confirm-commercial-change': 'true', 'x-change-reason': reason },
    body: JSON.stringify(values),
  }).then(parse);

export const deactivateCommercialResource = (resource, id, token, reason) =>
  fetch(`${API_BASE}/api/commercial/admin/${encodeURIComponent(resource)}/${encodeURIComponent(id)}/deactivate`, {
    method: 'POST', headers: { Authorization: `Bearer ${token}`, 'x-confirm-commercial-change': 'true', 'x-change-reason': reason },
  }).then(parse);

export const activateCommercialResource = (resource, id, token, reason) =>
  fetch(`${API_BASE}/api/commercial/admin/${encodeURIComponent(resource)}/${encodeURIComponent(id)}/activate`, {
    method: 'POST', headers: { Authorization: `Bearer ${token}`, 'x-confirm-commercial-change': 'true', 'x-change-reason': reason },
  }).then(parse);

export const deleteCommercialResource = (resource, id, token, reason) =>
  fetch(`${API_BASE}/api/commercial/admin/${encodeURIComponent(resource)}/${encodeURIComponent(id)}`, {
    method: 'DELETE', headers: { Authorization: `Bearer ${token}`, 'x-confirm-commercial-change': 'true', 'x-change-reason': reason },
  }).then(parse);

export const fetchCommercialHistory = (resource, id, token, signal) =>
  fetch(`${API_BASE}/api/commercial/admin/${encodeURIComponent(resource)}/${encodeURIComponent(id)}/history`, { headers: { Authorization: `Bearer ${token}` }, signal }).then(parse);

export const adjustCommercialCredits = (walletId, units, token, reason) =>
  fetch(`${API_BASE}/api/commercial/admin-credit-wallets/${encodeURIComponent(walletId)}/adjust`, {
    method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, 'x-confirm-commercial-change': 'true', 'x-change-reason': reason }, body: JSON.stringify({ units }),
  }).then(parse);

export const fetchAdminOffers = (token, signal) =>
  fetch(`${API_BASE}/api/commercial/admin-offers`, { headers: { Authorization: `Bearer ${token}` }, signal }).then(parse);

export const createAdminOffer = (values, token, reason) =>
  fetch(`${API_BASE}/api/commercial/admin-offers`, {
    method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, 'x-confirm-commercial-change': 'true', 'x-change-reason': reason },
    body: JSON.stringify(values),
  }).then(parse);

export const updateAdminOffer = (id, values, token, reason) =>
  fetch(`${API_BASE}/api/commercial/admin-offers/${encodeURIComponent(id)}`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, 'x-confirm-commercial-change': 'true', 'x-change-reason': reason },
    body: JSON.stringify(values),
  }).then(parse);

export const uploadOfferImage = async (file, token) => {
  const form = new FormData();
  form.append('image', await optimizeImageFile(file, 'BANNER'));
  return fetch(`${API_BASE}/api/commercial/admin-offers/image`, {
    method: 'POST', headers: { Authorization: `Bearer ${token}` }, body: form,
  }).then(parse);
};

export const fetchRevenueAnalytics = (token, signal) =>
  fetch(`${API_BASE}/api/commercial/admin-analytics/revenue`, { headers: { Authorization: `Bearer ${token}` }, signal }).then(parse);
